class Controls {
  constructor(
    uiActionMainContainerSelector,
    radioButtonsGroupSelector,
    inputFieldsGroup,
    options = {
      isSubPageRequired: true,
      isSubPage: false,
    }
  ) {
    this.uiActionMainContainerSelector = $(uiActionMainContainerSelector);
    this.radioButtonContainer = this.uiActionMainContainerSelector.find(
      radioButtonsGroupSelector
    );
    this.inputFieldsGroup = inputFieldsGroup;
    this.options = options;
  }

  getRadioButtonsGroup = () => {
    if (!this.uiActionTypeSelectionRadioButtons) {
      this.uiActionTypeSelectionRadioButtons = this.radioButtonContainer.find(
        "input[type='radio']"
      );
    }

    return this.uiActionTypeSelectionRadioButtons;
  };

  getResetButton = () => {
    if (!this.resetButton) {
      this.resetButton = this.radioButtonContainer.find(".reset-ui_action-btn");
    }

    return this.resetButton;
  };

  getDestroyField = () => {
    if (!this.destroyField) {
      this.destroyField = this.radioButtonContainer.find(
        ".destroy_ui_action_field"
      );
    }

    return this.destroyField;
  };

  getDestroyInfoPostFields = () => {
    if (!this.destroyInfoPostField) {
      this.destroyInfoPostField = this.options.isSubPage
        ? this.uiActionMainContainerSelector.find(".destroy_info_posts_field")
        : $();
    }

    return this.destroyInfoPostField;
  };

  toggleResetButtonAppearance = (bool) => {
    if (bool) {
      this.getResetButton().show();
    } else {
      this.getResetButton().hide();
    }
  };

  setDestroyFlag = (bool) => {
    this.getDestroyField().attr("value", bool);
  };

  setDestroyInfoPostFlag = (bool) => {
    const destroyInfoPostFields = this.getDestroyInfoPostFields();
    if (destroyInfoPostFields.length > 0) {
      destroyInfoPostFields.attr("value", bool);
    }
  };

  uncheckAllRadioButtons = () => {
    this.getRadioButtonsGroup().each((_, element) => {
      const ele = $(element);
      ele.attr("checked", null);
      ele.prop("checked", false);
    });
  };

  onRadioButtonChecked = (event) => {
    this.inputFieldsGroup.toggleRelevantUiActionFields(event.target.value);
    this.setDestroyFlag(null);
    this.toggleResetButtonAppearance(true);
    if (this.options.isSubPageRequired) {
      this.inputFieldsGroup.toggleSubPageRequiredField(
        event.target.value === "content"
      );
    }
    // if (event.target.value !== "post_items") {
    //   this.setDestroyInfoPostFlag(true);
    // } else {
    //   this.setDestroyInfoPostFlag(null);
    // }
  };

  onResetPressed = () => {
    this.setDestroyFlag(true);
    // this.setDestroyInfoPostFlag(true);
    this.toggleResetButtonAppearance(false);
    this.inputFieldsGroup.hideAllFields();
    this.uncheckAllRadioButtons();
  };

  initCheck = () => {
    // Look for checked button.
    const checkedUiActionTypeSelectionRadioButton = this.uiActionMainContainerSelector.find(
      "input[type='radio']:checked"
    );

    // Only show corresponding selected field(s).
    if (checkedUiActionTypeSelectionRadioButton.length > 0) {
      const currentSelectedValue = checkedUiActionTypeSelectionRadioButton.val();
      this.inputFieldsGroup.toggleRelevantUiActionFields(currentSelectedValue);
      this.inputFieldsGroup.toggleSubPageRequiredField(
        this.options.isSubPageRequired && currentSelectedValue === "content"
      );
    } else {
      // show nothing if nothing selected.
      this.toggleResetButtonAppearance(false);
      this.inputFieldsGroup.hideAllFields();
      this.inputFieldsGroup.toggleSubPageRequiredField(false);
    }
  };

  hide = () => {
    this.uiActionMainContainerSelector.hide();
  };

  show = () => {
    this.uiActionMainContainerSelector.show();
  };

  attach = () => {
    this.getRadioButtonsGroup().on("change", this.onRadioButtonChecked);
    this.getResetButton().on("click", this.onResetPressed);
    this.initCheck();
  };

  detach = () => {
    this.getRadioButtonsGroup().off("change", this.onRadioButtonChecked);
    this.getResetButton().off("click", this.onResetPressed);
  };
}

export default Controls;
